// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"dd1eb704","729":"f821cc0e"}[chunkId] + ".css";
};